import type {
  TypeGetDashboardDeliveryStatusParams,
  TypeGetDashboardDeliveryTrendParams,
  TypeGetOrdersParams,
  TypeGetOutboundsListParams,
  TypeGetShippingLabelsParams,
} from '~/types/delivery-agency.types';

/**
 * [배송 관리] React Query Key Factory
 */
export const deliveryAgencyKeys = {
  all: ['delivery-agency'] as const,

  /** 배송 주문 검색 필터 코드 조회 */
  orderSearchConditions: () => [...deliveryAgencyKeys.all, 'orderSearchConditions'] as const,

  /** 배송 주문 리스트 조회 */
  orders: (params: TypeGetOrdersParams) => [...deliveryAgencyKeys.all, 'orders', params] as const,

  /** 운송장 관리 검색 필터 코드 조회 */
  shippingLabelsSearchConditions: () => [...deliveryAgencyKeys.all, 'shippingLabelsSearchConditions'] as const,

  /** 운송장 관리 리스트 조회 */
  shippingLabels: (params: TypeGetShippingLabelsParams) =>
    [...deliveryAgencyKeys.all, 'shippingLabels', params] as const,

  /** 합포 단위 관리 검색 필터 코드 조회 */
  outboundsSearchConditions: () => [...deliveryAgencyKeys.all, 'outboundsSearchConditions'] as const,

  /** 합포 단위 관리 리스트 조회 */
  outboundsList: (params: TypeGetOutboundsListParams) => [...deliveryAgencyKeys.all, 'outboundsList', params] as const,

  /** 실시간 배송 현황 조회 */
  dashboardDeliveryStatus: (params: TypeGetDashboardDeliveryStatusParams) =>
    [...deliveryAgencyKeys.all, 'dashboardDeliveryStatus', params] as const,

  /** 배송 추이 조회 */
  dashboardDeliveryTrend: (params: TypeGetDashboardDeliveryTrendParams) =>
    [...deliveryAgencyKeys.all, 'dashboardDeliveryTrend', params] as const,
};
